/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The urgency determines the urgency of the transaction. The default value is `urgent`.
 */
export enum Urgency {
    NORMAL = 'normal',
    FAST = 'fast',
    URGENT = 'urgent',
}
